import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ptbrLocale from 'date-fns/locale/pt-BR';
import DateFnsAdapter from '@material-ui/lab/AdapterDateFns'; // choose your lib
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';

import GlobalStyle from './styles/global';

import AppProvider from './hooks';
import Routes from './routes';

const App: React.FC = () => (
  <Router basename="/meupantera">
    <AppProvider>
      <LocalizationProvider dateAdapter={DateFnsAdapter} locale={ptbrLocale}>
        <Routes />
      </LocalizationProvider>
    </AppProvider>

    <GlobalStyle />
  </Router>
);

export default App;
